"use strict";

exports.__esModule = true;

var _wixAxiosConfig = _interopRequireDefault(require("./src/wix-axios-config"));

exports.wixAxiosConfig = _wixAxiosConfig["default"];

var _wixAxiosInstanceConfig = _interopRequireDefault(require("./src/wix-axios-instance-config"));

exports.wixAxiosInstanceConfig = _wixAxiosInstanceConfig["default"];

var _wixAxiosServerConfig = _interopRequireDefault(require("./src/wix-axios-server-config"));

exports.wixAxiosServerConfig = _wixAxiosServerConfig["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }